import { render } from "./exo-sonification.vue?vue&type=template&id=b8241bc0&scoped=true&ts=true"
import script from "./exo-sonification.vue?vue&type=script&lang=ts"
export * from "./exo-sonification.vue?vue&type=script&lang=ts"

import "./exo-sonification.vue?vue&type=style&index=0&id=b8241bc0&lang=less&scoped=true"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8241bc0"]])

export default __exports__